import { useProcesses } from './useProcesses';
import { useMemo } from 'react';

export const useWorkspaceProcessCounts = () => {
  const { processes } = useProcesses();

  return useMemo(() => {
    const counts = new Map<string, number>();
    for (const process of processes) {
      if (process.archivedAt) {
        continue;
      }

      counts.set(
        process.workspaceId,
        (counts.get(process.workspaceId) ?? 0) + 1,
      );
    }

    return counts;
  }, [processes]);
};
